import React, { useState } from "react";

const ProgramCard = ({ item, reverse }) => {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) => (prev === item.images.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? item.images.length - 1 : prev - 1));
  };

  return (
    <div className={`program-card ${reverse ? "reverse" : ""}`}>
      {/* IMAGE SECTION */}
      <div className="program-image">
        <div className="main-image">
          <p className="age-badge">
            {item.age} <span>Years</span>
          </p>

          <button className="arrow left" onClick={prevSlide}>
            ‹
          </button>

          <img src={item.images[current]} alt={item.title} />

          <button className="arrow right" onClick={nextSlide}>
            ›
          </button>
        </div>

        <div className="thumbnail-row">
          {item.images.map((img, i) => (
            <img
              key={i}
              src={img}
              alt="thumb"
              className={current === i ? "active" : ""}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>
      </div>

      {/* CONTENT */}
      <div className="program-content">
        <h2>{item.title}</h2>
        <span className="program-content-fade">{item.title}</span>
        {item.description.map((para, index) => (
          <p key={index}>{para}</p>
        ))}

        <ul>
          {item.features?.map((i) => (
            <li>{i}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProgramCard;
